(function($){
        
	// Add Loaded Class
//	$('.ptx-spinner').addClass('ptx-spinner--loaded');
  
})(jQuery);